// https://github.com/verbit-ai/verbatizer/blob/master/app/models/role.rb
type ThirdPartyRole =
    | 'echo_captioner'
    | 'lingo_admin'
    | 'professional_captioner'
    | 'professional_captions_reviewer'
    | 'professional_service_servant'
    | 'audio_describer'
    | 'audio_describer_human_voicing'
type LegalFlowRole = 'legal_pro' | 'legal_certifier'
type TranscriberTraxRole = 'trax_editor' | 'trax_annotator' | 'trax_reviewer'
type T1Role = 'professional_editor' | 'professional_reviewer'
type TranscriberRole =
    | ThirdPartyRole
    | LegalFlowRole
    | TranscriberTraxRole
    | T1Role
    | 'punctuator'
    | 'type_corrector'
    | 'editor'
    | 'reviewer'
    | 'captionist'
    | 'merge_reviewer'
    | 'legal_annotator'
    | 'native_reviewer'
    | 'cover_pages_editor'
    | 'quality_controller'
    | 'supervisor'
    | 'admin'
    | 'trafficker'
    | 'cs_admin'
    | 'manual_encoder'
    | 'encoding_caption_quality_controller'
type CustomerRole =
    | 'customer_admin'
    | 'customer_editor'
    | 'customer_viewer'
    | 'customer_contributor'
    | 'customer_live_participant'
    | 'customer_content_manager'
    | 'collection_manager'
    | 'customer_approver'
    | 'lawyer'
    | 'court_reporter'

export type UserRole = TranscriberRole | CustomerRole

export type UserJSON = {
    user_id: number
    user_name: string | null
    company_name: string
    customer_id: number | null
    email: string
    rules: string[]
}

export type User = {
    userId: number
    userName: string | null
    companyName: string
    customerId: number | null
    email: string
    rules: UserRole[]
}

export const isUserWithRoles = (user: User | null, roles: UserRole[]) => {
    const rolesSet = new Set(roles)
    for (const role of user?.rules || []) {
        if (rolesSet.has(role)) {
            return true
        }
    }

    return false
}

export const toUser = (userJson: UserJSON): User => ({
    userId: userJson.user_id,
    userName: userJson.user_name,
    companyName: userJson.company_name,
    customerId: userJson.customer_id,
    email: userJson.email,
    rules: userJson.rules as UserRole[],
})
